import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import API from "../../utils/API";
import "./MenuBtns.css";

function ShopMenu() {
  const { id } = useParams();
  const history = useHistory();

  const returnToForest = async (event) => {
    event.preventDefault();
    sessionStorage.setItem("forestReturnPosition", JSON.stringify([384, 256]));

    try {
      await API.UpdateSpritePlace("forest", id);
    } finally {
      history.push("/forest/" + id + "?from=shop");
    }
  };

  return (
    <nav className="menu" aria-label="Shop menu">
      <h5>Menu</h5>
      <Link className="menu-btn" to={"/forest/" + id + "?from=shop"} onClick={returnToForest}>
        Return to Forest
      </Link>
      <Link className="menu-btn" to="/">
        Log Out!
      </Link>
    </nav>
  );
}

export default ShopMenu;
